//------------------------------------------------------ funciones
import {
  subscribeTable,
  createRow,
  updateRow,
  deleteRow,
} from "../supabaseRealtime";
import { realtime } from "../store";

const TABLA = "depositos";

// Realtime para listado
export const subscribeDepositos = (callback) => {
  return subscribeTable(TABLA, (rows) => {
    const depositos = rows.map((dp) => {
      const sucursales = realtime.ubicaciones || [];
      const articulos = realtime.stock || [];
      const sucursal = sucursales.find(
        (sc) => String(sc.id) === String(dp.sucursal),
      );
      const labelSucursal = sucursal?.label || "";

      const stockEnriquecido = (dp.stock || []).map((item) => {
        const articulo = articulos.find(
          (art) => String(art.id) === String(item.id),
        );

        return {
          ...item,
          descripcion: articulo?.descripcion || "",
          codigoProveedor: articulo?.codigoProveedor || "",
          marca: articulo?.marca || "",
          tipo: articulo?.tipo || "",
          nombreProveedor: articulo?.nombreProveedor || "",
        };
      });

      return {
        ...dp,
        nombreSucursal: labelSucursal,
        stock: stockEnriquecido,
      };
    });

    callback(depositos);
  });
};

export const createDeposito = ({ id, ...data }) => createRow(TABLA, id, data);
export const updateDeposito = (id, data) => updateRow(TABLA, id, data);
export const deleteDeposito = (id) => deleteRow(TABLA, id);
